<template>
  <div id="map-heat" style="height: 500px;"></div>
</template>

<script>
import L from 'leaflet'
import 'leaflet.heat'
import 'leaflet/dist/leaflet.css'

export default {
  props: ['data'],
  data() {
    return {
      map: null,
      heatLayer: null
    }
  },
  mounted() { this.initMap() },
  watch: {
    data() {
      this.renderMap()
    }
  },
  methods: {
    renderMap() {
      if (!this.map || !this.data) return
      
      if (this.heatLayer) {
        this.map.removeLayer(this.heatLayer)
      }
      
      this.heatLayer = L.heatLayer(this.data, { 
        radius: 10, 
        blur: 10, 
        maxZoom: 10
      }).addTo(this.map)
    },
    initMap() {
      if (!this.data) return

      this.map = L.map('map-heat').setView([24, 121], 8)
      this.heatLayer = L.heatLayer(this.data, { 
        radius: 10, 
        blur: 10, 
        maxZoom: 10
      }).addTo(this.map);

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(this.map);
    },
  }
}
</script>
